import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    Modal,
    ModalContent,
    Cross,
} from 'yurstrap';

import { closeModal } from '../reduxModules/App';

import { getLocationSelector } from '../../commons/selectors/RouterSelector';

import SupportContent from './SupportContent';

export class SupportModal extends Component {

    constructor(props) {
        super(props);
        this.onCloseModal = this.onCloseModal.bind(this);
    }

    onCloseModal() {
        const { AppActions } = this.props;
        AppActions.closeModal();
    }

    render() {
        const { location } = this.props;
        if (!location || !location.pathname) return null;
        return (
            <Modal onClose={this.onCloseModal}>
                <ModalContent
                    className="p-0"
                    style={{ minHeight: '600px' }}
                    width="xl"
                >
                    <Cross onClick={this.onCloseModal} />
                    <SupportContent location={location} />
                </ModalContent>
            </Modal>
        );
    }

}

SupportModal.propTypes = {
    AppActions: PropTypes.shape({
        closeModal: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
    return {
        location: ownProps.location || getLocationSelector(state),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        AppActions: bindActionCreators({
            closeModal,
        }, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SupportModal);
